<div class="text-nowrap">
  <label id="{{'chart-input-label-' + chartInput.id}}"
         for="{{'chart-input-' + chartInput.id}}"
         class="form-label mb-0 me-1">
    {{chartInput.label}}
  </label>
</div>
<div ngbDropdown [autoClose]="'outside'">
  <div class="input-group input-group-sm">
    <button id="{{'chart-input-' + chartInput.id}}"
            type="button"
            class="form-control"
            [class.border-radius-right-0]="value"
            ngbDropdownToggle>
      {{valueToDisplay}}
    </button>
    <button *ngIf="value"
            class="btn btn-light border-dark"
            type="button"
            (click)="clearSearchInputValue()">
      <i class="fa-light fa-xmark"></i>
    </button>
  </div>
  <div ngbDropdownMenu style="width: 100%;">
    <ng-container *ngFor="let dropdownItem of chartInput.dropdownItems">
      <button ngbDropdownItem
              id="{{dropdownItem.value}}"
              (click)="dropdownItem.selected = !dropdownItem.selected; valueChanged()"
              [class.active]="dropdownItem.selected">
        {{dropdownItem.text}}
      </button>
    </ng-container>
  </div>
</div>

